import React from "react";
import { Route, Redirect } from "react-router-dom";
import { cookieService } from "_services";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return cookieService.get("token") ? (
          <Component {...props} />
        ) : (
          <Redirect
            exact
            // to={{ pathname: "/", state: { from: props.location } }}
            to="/"
          />
        );
      }}
    />
  );
};
